import React, { useState } from "react";
import HcorzSidebar from "./HcorzSidebar";
import HcorzNavbar from "./HcorzNavbar";

const HcorzDashboard = ({ title, children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#eaf2f7] font-sans text-slate-900 overflow-hidden">
      {/* Sidebar */}
      <HcorzSidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-screen max-h-screen overflow-hidden">
        <HcorzNavbar
          title={title}
          onMenuClick={() => setMobileOpen(true)}
        />

        <main className="flex-1 overflow-auto bg-[#eaf2f7] relative p-2 md:p-3 flex flex-col min-h-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default HcorzDashboard;
